import { render } from "./SpeakerName.vue?vue&type=template&id=9a33fdaa&scoped=true&ts=true&lang=pug"
import script from "./SpeakerName.vue?vue&type=script&lang=ts"
export * from "./SpeakerName.vue?vue&type=script&lang=ts"

import "./SpeakerName.vue?vue&type=style&index=0&id=9a33fdaa&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a33fdaa"]])

export default __exports__